import React from 'react';
import './style.css';

import Icon_1 from '../../assets/icons/group.png';
import Icon_2 from '../../assets/icons/building.png';
import Icon_3 from '../../assets/icons/check.png';
import Icon_4 from '../../assets/icons/pipeline.png';
import Icon_5 from '../../assets/icons/headquarters.png';
import Icon_6 from '../../assets/icons/web.png';
import Icon_7 from '../../assets/icons/trophy.png';
import Icon_8 from '../../assets/icons/impact.png';
import Icon_9 from '../../assets/icons/calendar.png';

export default function StatisticsSection() {
  return (
    <>
      <div className='statistics-section'>
        <div className='statistics-row'>
          <div>
            <h2 class='section-title' style={{ color: '#fff' }}>
              At a <span>Glance</span>
            </h2>
            <p>A snapshot of our impact, growth, and vision</p>
          </div>

          <div className='statistics-blocks'>
            <div className='stat-block'>
              <img src={Icon_1} alt='Years of Combined Experience' />
              <h3>55+</h3>
              <h5>Years of <br /> Combined Experience</h5>
              <p>
                Led by a handpicked team of experts across real estate,
                construction, finance, and development
              </p>
            </div>
            <div className='stat-block'>
              <img src={Icon_2} alt='Square Feet Delivered' />
              <h3>698,600+</h3>
              <h5>
                Square Feet <br /> Delivered
              </h5>
              <p>
                Award-winning residential and mixed-use spaces across South
                Florida
              </p>
            </div>
            <div className='stat-block'>
              <img src={Icon_3} alt='Units Completed' />
              <h3>278</h3>
              <h5>
                Units <br /> Completed
              </h5>
              <p>With 500+ additional units actively in development</p>
            </div>
            <div className='stat-block'>
              <img src={Icon_9} alt='Units Completed' />
              <h3>2018</h3>
              <h5>
                Year <br /> Founded
              </h5>
              <p>
                Built on bold vision, precision, and a new era of urban
                development
              </p>
            </div>
            <div className='stat-block'>
              <img src={Icon_4} alt='Square Feet in Pipeline' />
              <h3>1.2M+</h3>
              <h5>
                Square Feet <br /> in Pipeline
              </h5>
              <p>Spanning Hollywood, Fort Lauderdale, and North Miami</p>
            </div>
            <div className='stat-block'>
              <img src={Icon_5} alt='Vertically Integrated' />
              <h3 className='text-stat-headline'>Vertically Integrated</h3>
              <h5>
                Affiliate <br /> Companies
              </h5>
              <p>
                Starlife Builders, Capital Ventures, Development, and
                International Realty ensure full-cycle execution
              </p>
            </div>
            <div className='stat-block'>
              <img src={Icon_6} alt='Global Reach' />
              <h3 className='text-stat-headline'>Global <br /> Reach</h3>
              <h5>
                Investors from <br /> 5+ Countries
              </h5>
              <p>
                Including strategic EB-5 partnerships fueling growth and
                innovation
              </p>
            </div>
            <div className='stat-block'>
              <img src={Icon_7} alt='Award-Winning' />
              <h3 className='text-stat-headline'>Award <br /> Winning</h3>
              <h5>Recognized by Titan & Luxury Lifestyle Awards</h5>
              <p>
                Honored for excellence in design, execution, and development
                leadership
              </p>
            </div>
            <div className='stat-block'>
              <img src={Icon_8} alt='Impact-Driven' />
              <h3 className='text-stat-headline'>Impact<br />Driven</h3>
              <h5>Focused on Quality & Community</h5>
              <p>
                Prioritizing sustainability, job creation, and long-term value
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
